import { useMemo } from 'react'
import { get, isNil } from 'lodash'

import { useQueryKG, TicketState } from '@common'

import { backendDocType, namespace } from './config'

import { CRUDO } from '../TicketHelper'

import { _query_kg } from './ticket.gql'

export function useScopeName(scope_id) {
  const { loading, data } = useQueryKG(_query_kg, {
    variables: {
      query: {
        op: 'eq',
        field: 'node_id',
        value: scope_id,
      },
    },
  })

  return useMemo(
    () => (loading || isNil(data) ? scope_id : get(data, 'query_kg.0.name')),
    [loading, data, scope_id],
  )
}

export const ticketProfile = {
  ticketType: backendDocType,
  namespace,
  states: [
    {
      main_state: TicketState.CREATE,
      assignee_quota: 1,
      assignee_as_editor: true,
      crud: CRUDO.RW_NO_OVERWRITE,
    },
    {
      main_state: TicketState.FINISH,
      assignee_quota: 0,
      assignee_as_editor: false,
      crud: CRUDO.READ_ONLY,
    },
  ],
  autoCreate: true,
  enableVersion: false,
  filterByCurrentUser: true,
}
